import { Card, CardContent, Grid, Skeleton } from '@mui/material';
import React from 'react';

interface CourseSkeletonsProps {
  count?: number;
}

export const CourseSkeletons: React.FC<CourseSkeletonsProps> = ({ count = 3 }) => {
  return (
    <Grid container spacing={3}>
      {Array.from(new Array(count)).map((_, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', borderRadius: '12px' }}>
            <Skeleton variant="rectangular" height={160} />
            <CardContent>
              <Skeleton height={32} width="80%" />
              <Skeleton height={24} width="40%" sx={{ mt: 1, mb: 1 }} />
              <Skeleton height={60} width="100%" sx={{ mt: 1, mb: 2 }} />
              <Skeleton height={48} width="100%" />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};